export default __webpack_public_path__ + "static/hero_mobile-bd88529a88b41aaa9ddeca33f4a79133.webp";